<template>
  <div :data-selector="SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO">
    <h1 class="heading-1 mb-32">
      {{ i18n(mainTitle) }}
    </h1>
    <p class="body-1">
      {{ i18n(bodyText) }}
    </p>
    <FormattedMessage
      id="collapsibleText"
      :class="[
        'body-1 block',
        {
          hidden: isCollapsed,
        },
      ]"
      :definition="hiddenBodyText"
    >
      <template
        v-for="(link, index) in links"
        :key="link.slotName"
        #[link.slotName]
      >
        <br v-if="index === 0" />
        <RevLink
          class="inline-block py-8 pr-8"
          target="_blank"
          :to="resolveLocalizedRoute(link.to)"
        >
          {{ i18n(link.label) }}
        </RevLink>
        <br v-if="index === links.length - 1" />
      </template>
    </FormattedMessage>

    <RevLink
      aria-controls="collapsibleText"
      :aria-expanded="!isCollapsed"
      class="mt-8 p-0"
      @click="toggleCollapsedState"
    >
      {{ i18n(toggleLabel) }}
    </RevLink>
  </div>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale } from '#imports'
import { computed, ref } from 'vue'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import type { SeoTextLink } from '../../constants'
import translations from '../../translations/SeoText.translations'

const {
  mainTitle,
  bodyText,
  hiddenBodyText,
  links = [],
} = defineProps<{
  mainTitle: I18nDefinition
  bodyText: I18nDefinition
  hiddenBodyText: I18nDefinition
  links?: SeoTextLink[]
}>()

const i18n = useI18n()
const resolveLocalizedRoute = useRouteLocationWithLocale()

const SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'reviews-text'
const isCollapsed = ref(true)

const toggleLabel = computed(() =>
  isCollapsed.value ? translations.seeMore : translations.seeLess,
)

function toggleCollapsedState() {
  isCollapsed.value = !isCollapsed.value
}
</script>
